import { EntityId } from 'entities-next/common'

import { SCOUTING_CAMPAIGN_MANAGER_DETAILS_PATH } from '../../ScoutingCampaignManager.routes'

export const SCOUTING_CAMPAIGN_MANAGER_DETAILS_FORM_DATA_PATH = `${SCOUTING_CAMPAIGN_MANAGER_DETAILS_PATH}/details`
export function getScoutingCampaignDetailsFormDataPath(scoutingCampaignId: EntityId) {
  return SCOUTING_CAMPAIGN_MANAGER_DETAILS_FORM_DATA_PATH.replace(':scoutingCampaignId', `${scoutingCampaignId}`)
}
export const SCOUTING_CAMPAIGN_MANAGER_SEARCH_CANDIDATE_LIST_PATH = `${SCOUTING_CAMPAIGN_MANAGER_DETAILS_PATH}/search-candidates`
export function getScoutingCampaignSearchCandidatesViewPath(scoutingCampaignId: EntityId) {
  return SCOUTING_CAMPAIGN_MANAGER_SEARCH_CANDIDATE_LIST_PATH.replace(':scoutingCampaignId', `${scoutingCampaignId}`)
}

export const SCOUTING_CAMPAIGN_MANAGER_SEARCH_CANDIDATE_RESULTS_PATH = `${SCOUTING_CAMPAIGN_MANAGER_DETAILS_PATH}/search-candidates/:searchCandidateId/results`
export function getScoutingCampaignSearchCandidatesResultsViewPath(
  scoutingCampaignId: EntityId,
  searchCandidateId: EntityId
) {
  return SCOUTING_CAMPAIGN_MANAGER_SEARCH_CANDIDATE_RESULTS_PATH.replace(
    ':scoutingCampaignId',
    `${scoutingCampaignId}`
  ).replace(':searchCandidateId', `${searchCandidateId}`)
}
